'use strict';

var request = require('./blueAgent');
var assign = require('object-assign');
var ServiceClientBase = require('./serviceClientBase');

module.exports = assign({}, ServiceClientBase.prototype, {

    /**
     * Gets a menu for a store
     *
     * @param params
     * @param {string} params.cntry
     * @param {string} params.lang
     * @param {string} params.sourceCode defaults to UNIFIED
     * @param {string} params.version defaults to 2.0.0
     * @param {string} params.siteNum locaiton id / site id
     * @param {object} headers
     */
    getSiteMenu: function getSiteMenu(params, headers) {
        if (!params) {
            throw Error('missing params');
        }

        if (!params.siteNum) {
            throw Error('must supply siteNum!');
        }

        //pull out ONLY what we want to send along...
        var sentParams = this.pullQueryStringParams(params);
        sentParams.siteNum = params.siteNum;

        //for GET's, we don't need to pull query string values out of params passed in
        return this.getApiRequest(this.getUrl().menuGetSiteMenu, sentParams, headers);
    },

    /**
     * Gets the order modes from a menu for a store
     *
     * @param params
     * @param {string} params.cntry
     * @param {string} params.lang
     * @param {string} params.sourceCode defaults to UNIFIED
     * @param {string} params.version defaults to 2.0.0
     * @param {string} params.siteNum locaiton id / site id
     */
    getSiteOrderModes: function getSiteOrderModes(params) {
        if (!params) {
            throw Error('missing params');
        }

        if (!params.siteNum) {
            throw Error('must supply siteNum!');
        }

        //pull out ONLY what we want to send along...
        var sentParams = this.pullQueryStringParams(params);
        sentParams.siteNum = params.siteNum;

        //for GET's, we don't need to pull query string values out of params passed in
        return this.getApiRequest(this.getUrl().menuGetSiteOrderModes, sentParams);
    },

    /**
     * Gets the national menu
     * @param {string} params.cntry country
     * @param {string} params.lang language
     * @param {string} params.sourceCode sourceCode
     * @param {string} params.version version
     * @returns {promise}
     */
    getNationalMenu: function getNationalMenu(params) {
        return this.getApiRequest(this.getUrl().menuGetNationalMenu, this.pullQueryStringParams(params));
    },

    /**
     * Gets the order modes from the national menu
     *
     * @param {string} params.cntry country
     * @param {string} params.lang language
     * @param {string} params.sourceCode sourceCode
     * @param {string} params.version version
     * @returns {promise}
     */
    getNationalOrderModes: function getNationalOrderModes(params) {
        if (!params) {
            throw Error('missing params');
        }

        //pull out ONLY what we want to send along...
        var sentParams = this.pullQueryStringParams(params);

        //for GET's, we don't need to pull query string values out of params passed in
        return this.getApiRequest(this.getUrl().menuGetNationalOrderModes, sentParams);
    },

    /**
     * Get UpSell products list
     * @param {string} params.cntry country
     * @param {string} params.lang language
     * @param {string} params.sourceCode sourceCode
     * @param {string} params.version version
     * @returns {promise}
     */
    getUpSell: function getUpSell(params) {
        if (!params) throw Error('missing params');

        var sendParams = this.pullQueryStringParams(params);

        return this.getApiRequest(this.getUrl().menuGetUpSell, sendParams);
    },

    /**
     * Get LTO(campaign) product list
     * @param {string} params.cntry country
     * @param {string} params.lang language
     * @param {string} params.sourceCode sourceCode
     * @param {string} params.version version
     * @returns {promise}
     */
    getCampaign: function getCampaign(params) {
        if (!params) throw Error('missing params');

        var sendParams = this.pullQueryStringParams(params);

        return this.getApiRequest(this.getUrl().menuGetCampaign, sendParams);
    },

    /**
     * Get sales items
     *
     * @param {string} params.cntry country
     * @param {string} params.lang language
     * @param {string} params.sourceCode sourceCode
     * @param {string} params.version version
     * @param {string} params.siteNum site number
     * @param {string} [params.size] size enum value provided by services
     * @param {string} [params.salesGroupId] sales group id
     * @param {string} [params.salesItemId] sales item id
     * @param {string} [params.menuItemId] menu item id
     * @param {string} [params.productId] product id
     * @returns {promise}
     */
    getSalesItems: function getSalesItems(params) {
        if (!params) throw Error('missing params');

        return this.getApiRequest(this.getUrl().menuGetSalesItems, params);
    }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/service_clients/menuServiceClient.js
// module id = 765
// module chunks = 0